import React, {Component} from 'react';
import moment from 'moment';
import Modal from '../components/Modal';
import UserAvatar from './UserAvatar';

class EmailAttachmentLink extends Component {

    render() {
        var link = __CANDY_CRM_API_HOST__ + "email/attachment/" + this.props.gmailId + '/' + this.props.attachment;

        if (this.props.attachment.indexOf('.png') > 0 || this.props.attachment.indexOf('.jpg') > 0){
            return <a target="_blank" href={link}><img style={{maxHeight : '200px', maxWidth : '200px'}} src={link} /></a>            
        }

        return <a target="_blank" href={link}><i className="fa fa-file"></i> {this.props.attachment}</a>        
    }
}

export default class FullEmailModal extends Component {
    
    render() {

        var actionButton = <button className="btn btn-success" onClick={this.props.closeModal.bind(this)}>Close</button>
        var attachments = [];
        if (this.props.email.attachments){
            attachments = JSON.parse(this.props.email.attachments);
        }
        
        return (
            <Modal actionButton={actionButton} showCancel={false} className="modal-success" title={this.props.email.subject}>
                <div className="page-todo">
                    <div className="task">
                        <span className="taskSpan">
                            <span className="type taskSpan">{ this.props.user && 
                                <UserAvatar user={this.props.user} />
                            }
                            <span className="pull-right">{ moment(this.props.email.emailDate).format("dd/MM/YYYY h:mm a") }</span>
                            <span className="pull-left">From: {this.props.to} -> To: {this.props.to}</span>
                            </span>
                            <br/>
                            <h3 style={{fontWeight: 'bold'}}>
                                {this.props.email.subject}
                            </h3>
                            <pre style={{maxHeight : '300px'}} className="taskSpan" dangerouslySetInnerHTML={{__html: this.props.email.body}} ></pre>                            
                            { attachments.length > 0 && 
                                <div>Attachments:
                                    <ul style={{listStyle : 'none'}}>          
                                        { attachments.map((attachment) => <li><EmailAttachmentLink gmailId={this.props.email.gmailId} attachment={attachment} /></li> )}
                                        
                                    </ul>
                                </div>
                            } 
                        </span>                        
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/FullEmailModal.js